import app from '@wtdc/feed';
import Container from '@/routes/index';

app.useHistory().useRedux().useRouter(Container).attach(document.getElementById('App'));

if (module.hot) {
  module.hot.accept();
}

export default app;
